import { Component, Input, OnInit } from '@angular/core';
import { MessageWrapperService } from 'src/app/services/message-wrapper.service';
import { ReportGenSvc, ReportTile, Role } from 'src/app/services_autogenerated/generated_services';

@Component({
    selector: 'app-report-tile-default-section',
    templateUrl: './report-tile-default-section.component.html',
    styleUrls: ['./report-tile-default-section.component.css'],
    standalone: false
})
export class ReportTileDefaultSectionComponent implements OnInit {
  @Input() role: Role;
  @Input() allReportTiles: ReportTile[];

  selectedReports: number[] = [];

  constructor(private reportService: ReportGenSvc, private messageService: MessageWrapperService) { }

  ngOnInit() {
    this.reportService.getRoleAssignedReports(this.role.id).subscribe(res => {
      this.selectedReports = res.map(rt => rt.reportTileId);
    });
  }

  modelChange(checked, roleId: number, reportTileId: number, id: number) {
    if (checked) {
      this.reportService.addRoleAssignedReport(roleId, reportTileId).subscribe(res => {
        this.messageService.addSuccessMessage('Added default successfully.');
      })
    } else {
      this.reportService.deleteRoleAssignedReport(roleId, reportTileId).subscribe(res => {
        this.messageService.addSuccessMessage('Removed default successfully.');
      })
    }
  }
}
